import { asyncActionCreator } from 'src/utils/loadingUtils';
import { SnackBarVariants } from 'src/utils/constants/common';
import {
  getCardMovements,
  downloadCardMovementsExcel
} from 'src/services/cardMovementsService';
import { sendCreditCardPaymentLink } from 'src/services/paymentService';
import { selectCardMovementsQueryOptions } from '../selectors/cardMovementsSelectors';
import { showMessage } from './snackBarActions';

export const LOAD_CARD_MOVEMENTS = asyncActionCreator('LOAD_CARD_MOVEMENTS');
export const DOWNLOAD_CARD_MOVEMENTS = asyncActionCreator(
  'DOWNLOAD_CARD_MOVEMENTS'
);
export const SEND_CREDIT_CARD_PAYMENT_LINK = asyncActionCreator(
  'SEND_CREDIT_CARD_PAYMENT_LINK'
);
export const SAVE_CARD_MOVEMENTS_OPTIONS = 'SAVE_CARD_MOVEMENTS_OPTIONS';
export const CLEAR_CARD_MOVEMENTS_OPTIONS = 'CLEAR_CARD_MOVEMENTS_OPTIONS';
export const CLEAR_CARD_MOVEMENTS = 'CLEAR_CARD_MOVEMENTS';

function getOptions(getState, sendLimit = true) {
  const queryOpts = selectCardMovementsQueryOptions(getState());
  const reqOptions = {};

  if (queryOpts.page > 0) {
    reqOptions.offset =
      queryOpts.page * Number(process.env.REACT_APP_TABLE_SIZE);
  }
  if (queryOpts.clientName) {
    reqOptions.clientName = queryOpts.clientName;
  }
  if (sendLimit) {
    reqOptions.limit = queryOpts.limit;
  }
  return reqOptions;
}

export const clearOptions = () => dispatch => {
  dispatch({ type: CLEAR_CARD_MOVEMENTS_OPTIONS });
};

export const loadCardMovements = options => async (dispatch, getState) => {
  try {
    dispatch({ type: LOAD_CARD_MOVEMENTS.start });

    dispatch({
      type: SAVE_CARD_MOVEMENTS_OPTIONS,
      options
    });

    const reqOptions = getOptions(getState);
    const response = await getCardMovements(reqOptions);

    return dispatch({
      type: LOAD_CARD_MOVEMENTS.success,
      items: response.items,
      count: response.count
    });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: LOAD_CARD_MOVEMENTS.failure });
  }
};

export const downloadCardMovements = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DOWNLOAD_CARD_MOVEMENTS.start });

    const reqOptions = getOptions(getState, false);
    await downloadCardMovementsExcel(reqOptions);

    dispatch(
      showMessage({
        message: 'DOWNLOAD_CARD_MOVEMENTS_SUCCESS',
        variant: SnackBarVariants.SUCCESS
      })
    );

    return dispatch({ type: DOWNLOAD_CARD_MOVEMENTS.success });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: DOWNLOAD_CARD_MOVEMENTS.failure });
  }
};

export const sendCreditCardPaymentLinkAction = (
  values,
  closeCallback
) => async dispatch => {
  try {
    dispatch({ type: SEND_CREDIT_CARD_PAYMENT_LINK.start });

    const invoices = values.invoices.map(invoice => ({
      invoiceId: invoice.id,
      amount: invoice.amountToPay
    }));

    await sendCreditCardPaymentLink({
      clientId: values.clientId,
      invoices
    });

    dispatch(
      showMessage({
        message: 'PAYMENT_LINK_SENT',
        variant: SnackBarVariants.SUCCESS
      })
    );

    closeCallback();
    dispatch(loadCardMovements());
    return dispatch({ type: SEND_CREDIT_CARD_PAYMENT_LINK.success });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    closeCallback();
    return dispatch({ type: SEND_CREDIT_CARD_PAYMENT_LINK.failure });
  }
};
